import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appThreeDigitOneDecimal]',
    standalone: false
})
export class ThreeDigitOneDecimalDirective {

  private regex: RegExp = new RegExp(/^\d{0,3}(\.\d{0,1})?$/); // Allows up to 3 digits before the decimal and 1 digit after
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];

  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {

    if (this.specialKeys.includes(event.key)) {
      return; // Allow special keys
    }

    const inputElement = event.target as HTMLInputElement;
    const current: string = inputElement.value;
    const next: string = current.concat(event.key);


    // Prevent input if it doesn't match the regex
    if (!this.regex.test(next)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    const pastedInput = clipboardData?.getData('text') ?? '';

   

    if (!this.regex.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
